import { render, staticRenderFns } from "./super-food-detail.vue?vue&type=template&id=072ca584&scoped=true&"
import script from "./super-food-detail.vue?vue&type=script&lang=js&"
export * from "./super-food-detail.vue?vue&type=script&lang=js&"
import style0 from "./super-food-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./super-food-detail.vue?vue&type=style&index=1&id=072ca584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ca584",
  null
  
)

export default component.exports